import LOGO from './logo.png'

export default function Logo (props) {
    return <img src={LOGO} {...props} />
}
